import { ReactElement } from 'react';

import DiscordIcon from '@/icons/discord';
import LinkedinIcon from '@/icons/linkedIn';
import MediumIcon from '@/icons/medium';
import TelegramIcon from '@/icons/telegram';
import TwitterIcon from '@/icons/twitter';
import YoutubeIcon from '@/icons/youtube';

interface FooterSocialIconsProps {
	url?: string;
	icon: ReactElement;
	iconName: string;
}

const ICON_CLASS = 'text-inherit opacity-70 group-hover:scale-125 transition-all ease-in-out duration-300';

const FOOTER_SOCIAL_ICONS: FooterSocialIconsProps[] = [
	{
		url: 'https://t.me/SupraOracles',
		icon: <TelegramIcon className={ICON_CLASS} />,
		iconName: 'Telegram',
	},
	{
		url: 'https://twitter.com/SupraOracles',
		icon: <TwitterIcon className={ICON_CLASS} />,
		iconName: 'X',
	},
	{
		url: 'https://www.linkedin.com/company/supraoracles/',
		icon: <LinkedinIcon className={ICON_CLASS} />,
		iconName: 'Linkedin',
	},
	{
		url: 'https://medium.com/@SupraOracles',
		icon: <MediumIcon className={ICON_CLASS} />,
		iconName: 'Medium',
	},
	{
		url: 'https://discord.com/invite/supralabs',
		icon: <DiscordIcon className={ICON_CLASS} />,
		iconName: 'Discord',
	},
	{
		url: 'https://www.youtube.com/SupraOfficial',
		icon: <YoutubeIcon className={ICON_CLASS} />,
		iconName: 'You Tube',
	},
];

const SocialIcons = ({
	wrapperClassName,
	iconClassName,
}: {
	wrapperClassName?: string;
	iconClassName?: string;
}): ReactElement => (
	<div
		className={`grid grid-cols-6 items-center justify-center gap-y-4 py-1 md:grid-cols-3 lg:grid-cols-6 lg:gap-0 ${wrapperClassName}`}>
		{FOOTER_SOCIAL_ICONS.map(({ url, icon, iconName }) => (
			<a
				href={url}
				key={url}
				target="_blank"
				rel="noreferrer"
				className="group"
				aria-label={`Follow Us On ${iconName}`}>
				<div className={`text-default-color relative flex h-5 w-5 items-center justify-center ${iconClassName}`}>
					{icon}
				</div>
			</a>
		))}
	</div>
);

export default SocialIcons;
